import React, { Component } from 'react';
import { isEmpty } from 'lodash';
import { withTranslation } from 'react-i18next';
import PhoneField from 'components/v2/forms/PhoneField';
import FormCard from '../../v2/FormCard';
import UserActionCreators from '../../../actions/UserActionCreators';
const getEmptyState = () => {
    return {
        vendor: {
            company_name: '',
            email: '',
            first_name: '',
            last_name: '',
            password: '',
            phone: '',
        },
    };
};
class RegisterVendor extends Component {
    constructor(props) {
        super(props);
        this.handlePhoneChange = (phone) => {
            this.setState((prevState) => {
                return {
                    vendor: Object.assign(Object.assign({}, prevState.vendor), { phone }),
                };
            });
        };
        this.handleChange = (field) => (e) => {
            const { target: { value }, } = e;
            this.setState((prevState) => {
                return {
                    vendor: Object.assign(Object.assign({}, prevState.vendor), { [field]: value }),
                };
            });
        };
        this.handleRegister = (e) => {
            e.preventDefault();
            const { vendor } = this.state;
            UserActionCreators.addVendor(Object.assign({}, vendor));
            this.setState(getEmptyState());
        };
        this.state = getEmptyState();
    }
    render() {
        const { vendor } = this.state;
        const { t } = this.props;
        const disabled = isEmpty(vendor.company_name) ||
            isEmpty(vendor.email) ||
            isEmpty(vendor.first_name) ||
            isEmpty(vendor.last_name) ||
            isEmpty(vendor.password) ||
            isEmpty(vendor.phone);
        return (React.createElement(FormCard, { actions: () => (React.createElement("button", { disabled: disabled, className: "button button-green", type: "submit", onClick: this.handleRegister }, t('REGISTER_VENDOR'))) },
            React.createElement("div", { className: "mb-4" },
                React.createElement("h3", { className: "text-lg font-medium text-gray-900 leading-6" }, t('VENDOR_PROFILE'))),
            React.createElement("div", { className: "grid grid-cols-4 gap-6" },
                React.createElement("div", { className: "col-span-4 sm:col-span-2" },
                    React.createElement("label", { className: "block mb-2 form-label" }, t('FIRST_NAME')),
                    React.createElement("input", { className: "w-full mb-4 form-field", type: "text", placeholder: "John", onChange: this.handleChange('first_name'), value: vendor.first_name })),
                React.createElement("div", { className: "col-span-4 sm:col-span-2" },
                    React.createElement("label", { className: "block mb-2 form-label" }, t('LAST_NAME')),
                    React.createElement("input", { className: "w-full mb-4 form-field", type: "text", placeholder: "Smith", onChange: this.handleChange('last_name'), value: vendor.last_name })),
                React.createElement("div", { className: "col-span-4 sm:col-span-2" },
                    React.createElement("label", { className: "block mb-2 form-label" },
                        React.createElement("span", null, t('COMPANY_NAME'))),
                    React.createElement("input", { className: "w-full mb-4 form-field", type: "text", placeholder: t('COMPANY_NAME'), onChange: this.handleChange('company_name'), value: vendor.company_name })),
                React.createElement("div", { className: "col-span-4 sm:col-span-2" },
                    React.createElement("label", { className: "block mb-2 form-label" }, t('PHONE')),
                    React.createElement(PhoneField, { id: "vendor-phone", onChange: this.handlePhoneChange, value: vendor.phone })),
                React.createElement("div", { className: "col-span-4 sm:col-span-2" },
                    React.createElement("label", { className: "block mb-2 form-label" }, t('EMAIL')),
                    React.createElement("input", { className: "w-full mb-4 form-field", type: "email", placeholder: "example@cargomatic.com", onChange: this.handleChange('email'), value: vendor.email })),
                React.createElement("div", { className: "col-span-4 sm:col-span-2" },
                    React.createElement("label", { className: "block mb-2 form-label" }, t('PASSWORD')),
                    React.createElement("input", { className: "w-full mb-4 form-field", type: "password", placeholder: t('PASSWORD'), onChange: this.handleChange('password'), value: vendor.password })))));
    }
}
export default withTranslation()(RegisterVendor);
